// gallery
export const SHOW_GALLERY = 'media:show_gallery';
export const IMAGE_SELECTED = 'media:image_selected';

// config
export const ROUTES_CHANGED = 'routes:changed';

// language
export const LANGUAGE_CHANGED = 'language:changed';
